import VTableWrapper from './index.vue'

export default VTableWrapper
